module.exports = __webpack_public_path__ + "static/6-ways-the-pandemic-is-changing-flexible-workspace-d957246fb3a0a74acee277968fd25a77.png";